export default "__VITE_ASSET__DiQ2Rz8b__"